/* HARDSEN (04/11/2026 soir) : les cadeaux du savon entrent dans le panier avec le lot de 2 savons coréens et le suivent.
   Règle : pour chaque cadeau (après-shampooing coréen, cadeau mystère), quantité = nombre de lots de 2 savons coréens dans le panier.
   Lot ajouté ou augmenté : les cadeaux entrent ; lot baissé ou retiré (« − », corbeille) : ils suivent ; un cadeau retiré à la main revient tant que le lot est là.
   Se déclenche après chaque appel du thème à /cart/add, /cart/change, /cart/update, /cart/clear, puis rafraîchit le tiroir (HSPanier.rafraichir).
   Variantes : lot « 2 savons coréens » 68049724506362 ; cadeaux 68083628376314 (après-shampooing) et 68083628474618 (cadeau mystère), à 0,00 €, produits non listés. */
(function () {
  if (window.SVCadeaux) return;
  var LOT = 68049724506362;
  var CADEAUX = [68083628376314, 68083628474618];
  var natif = window.fetch.bind(window);
  var occupe = false, encore = false;
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function lirePanier() { return natif('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function accorder() {
    if (occupe) { encore = true; return Promise.resolve(); }
    occupe = true;
    return lirePanier().then(function (c) {
      var lots = 0;
      c.items.forEach(function (i) { if (i.variant_id === LOT) lots += i.quantity; });
      var ajouts = [], changements = [];
      CADEAUX.forEach(function (id) {
        var ligne = null;
        c.items.forEach(function (i) { if (i.variant_id === id && !ligne) ligne = i; });
        var a = ligne ? ligne.quantity : 0;
        if (a === lots) return;
        if (ligne) changements.push({ id: ligne.key, quantity: lots });
        else ajouts.push({ id: id, quantity: lots });
      });
      var etapes = Promise.resolve();
      if (ajouts.length) etapes = etapes.then(function () { return natif('/cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: ajouts }) }); });
      changements.forEach(function (ch) { etapes = etapes.then(function () { return natif('/cart/change.js', { method: 'POST', headers: JSONH, body: JSON.stringify(ch) }); }); });
      return etapes.then(function () { if ((ajouts.length || changements.length) && window.HSPanier) return window.HSPanier.rafraichir(); });
    }).catch(function () {}).then(function () {
      occupe = false;
      if (encore) { encore = false; accorder(); }
    });
  }

  window.fetch = function (resource, options) {
    var p = natif(resource, options);
    try {
      var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(function () { setTimeout(accorder, 60); }, function () {});
    } catch (e) {}
    return p;
  };

  window.SVCadeaux = { accorder: accorder };
  if (/(^|;\s*)cart=/.test(document.cookie)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', accorder); else accorder();
  }
})();
